import React from 'react'
import { notification } from 'antd'

const Notification = ({
    title,
    description,
    type = 'info',
    placement = 'top',
}) => {
    const [api, contextHolder] = notification.useNotification()
    const [mounted, setMounted] = React.useState(false)

    React.useEffect(() => {
        if (mounted) return

        if (api[type]) {
            api[type]({
                title,
                description,
                placement,
            })
        }

        setMounted(true)
    }, [api, description, mounted, placement, title, type])

    return <>{contextHolder}</>
}

export const ValidationIssuesDescription = ({ issues }) => (
    <div>
        <div>Укажите значения для:</div>
        <ul style={{ margin: '8px 0 0', paddingLeft: '20px' }}>
            {issues.map(({ label, hint }) => (
                <li key={`${label}-${hint || ''}`}>
                    {hint ? `${label} — ${hint}` : label}
                </li>
            ))}
        </ul>
    </div>
)

export default Notification
